import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode'; // Import named export

@Injectable()
export class JwtService {
  // Return a object from token
  public decode<TDecode>(token: string): TDecode {
    const decodedToken = jwtDecode<TDecode>(token); // Use jwtDecode directly
    return decodedToken;
  }
}
